export const tokenChipId = (prefix: string, index: number): string => `${prefix}-token-${index}`;
